import { z } from "zod";
import { GENRE_VALUES } from "../../constants/genre.js";
import { StoryViewerStateSchema } from "./social.js";
export const StoryStatsSchema = z.object({
    likes: z.number().int().nonnegative(),
    comments: z.number().int().nonnegative(),
    bookmarks: z.number().int().nonnegative(),
});
export const StorySummarySchema = z.object({
    id: z.uuid(),
    seriesId: z.uuid(),
    episodeNumber: z.number().int().positive(),
    title: z.string(),
    synopsis: z.string(),
    genre: z.enum(GENRE_VALUES),
    coverUrl: z.url(),
    previewVideoUrl: z.url().nullable(),
    estimatedDurationSeconds: z.number().nonnegative(),
    endingsCount: z.number().int().nonnegative(),
    stats: StoryStatsSchema,
    viewer: StoryViewerStateSchema,
});
export const StoryFeedSchema = z.object({
    stories: z.array(StorySummarySchema),
});
